import { apiClient } from '@/utils/axios.ts'

const toggleAiTranslator = async (
  creatorId: number | undefined,
  toggleData: { state: boolean },
): Promise<void> => {
  const response = await apiClient.put('settings/ai-translation', toggleData, {
    params: { creatorId },
  })

  return response.data
}

export const aiSettingsService = {
  toggleAiTranslator,
}
